<template>
    <v-card>
        <v-card-title  class="grey lighten-4 p-2">
            <h4 class="m-0">Delivery</h4>
        </v-card-title>
        <v-row class="m-2">
            <v-col cols="12" md="6">
                <h6>Day before</h6>
                <v-row>
                    <v-col cols="6" md="5">
                        <v-radio-group
                            v-model="reservation.pickup_day"
                            row
                        >
                            <v-radio
                                label="Yes"
                                value="day_before"
                            ></v-radio>
                            <v-radio
                                label="No"
                                value="day_of"
                            ></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="6" md="7">
                        <with-validation v-slot="{bind,on}" field="pickup_hour">
                            <v-select
                                v-model="reservation.pickup_hour"
                                :items="pickup_hours"
                                item-value="value"
                                item-text="time"
                                label="Select pickup time"
                            ></v-select>
                        </with-validation>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" md="5">
                <v-alert
                    outlined
                    elevation="2"
                >
                    <b>Select preferred delivery day and time: </b> <h6>(we are showing all the times that are available for that day, if your preferred time is not available select the best time for your group)</h6>
                    <b> Do you want to pick up the day before? </b> <h6> (If you select "No", you will be picking up on the day of your reservation) </h6>
                </v-alert>
            </v-col>
        </v-row>
        <v-row class="m-2 pb-5">
            <v-col cols="12" md="7" style="margin-bottom: -30px;">
                <h6>Please select a time for your delivery, times are limited to 1 delivery per hour</h6>
                <h6>Do you know the Property Name or Address you will be staying:</h6>
            </v-col>
            <v-col cols="12" md="5">
                <v-radio-group
                    v-model="delivery_address_radio"
                    row>
                    <v-radio
                        label="Yes"
                        :value=true
                    ></v-radio>
                    <v-radio
                        label="No"
                        :value=false
                    ></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import UiManagerMixin from "../../../../mixins/UiManagerMixin";
import {mapActions} from "vuex";
import WithValidation           from "../../../../components/inputs/WithValidation";
import ValidatableComponent from "../../../../mixins/ValidatableComponent";

export default {
    name: "DeliveryBlock",
    components: {WithValidation},
    mixins: [UiManagerMixin, ValidatableComponent],
    data      : () => ({
        pickupTimeType: "no",
        delivery_address_radio: false
    }),
    computed: {
        reservation() {
            return this.$store.state.model.reservation;
        },
        pickup_hours() {
            return this.$store.state.resources.pickup_hours.pickup_hours;
        }
    },
    watch     : {
        delivery_address_radio(newVal) {
            if(newVal){
                this.ui__openModalByName({name:'dialog_delivery_address'})
            }
        },
        'reservation.pickup_day': function (newVal) {
            this.load__pickup_hours(new Date(), newVal);
        },
    },
    methods: {
        ...mapActions(['load__pickup_hours']),
    }
}
</script>

<style scoped>

</style>
